import React, { useEffect, useState } from 'react'
import SiderCard from '../../components/pages/ReportDetails/SiderCard'
import { Button, Col, Flex, Row } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { setNavBredcrumb } from '../../store/reducers/slices/topnav.slice'
import { Link, useParams } from 'react-router-dom'
import ZCard from '../../components/Card/Index'
import { ReportTabs } from '../../utils/ConstantData'
import SummaryReport from '../../components/pages/ReportDetails/ReportTabs/SummaryReport'
import OverviewReport from '../../components/pages/ReportDetails/ReportTabs/OverviewReport'
import EmiPayments from '../../components/pages/ReportDetails/ReportTabs/EmiPayments'
import LoanAnalysis from '../../components/pages/ReportDetails/ReportTabs/LoanAnalysis'
import Loans from '../../components/pages/ReportDetails/ReportTabs/Loans'
import TransactionReport from '../../components/pages/ReportDetails/ReportTabs/TransactionReport'
import AMLAnalysisReport from '../../components/pages/ReportDetails/ReportTabs/AMLAnalysisReport'
import MonthlySummaryReport from '../../components/pages/ReportDetails/ReportTabs/MonthlySummaryReport'
import DailyBalanceReport from '../../components/pages/ReportDetails/ReportTabs/DailyBalanceReport'
import SalaryReport from '../../components/pages/ReportDetails/ReportTabs/SalaryReport'
import IrregularitiesPageWrapper from '../../components/pages/ReportDetails/ReportTabs/Irregularities'
import UPITxnAnalysisWrapper from '../../components/pages/ReportDetails/ReportTabs/UPITxnAnalysis'
import AvailableBalance from '../../components/pages/ReportDetails/ReportTabs/AvailableBalance'
import RecurringPayments from '../../components/pages/ReportDetails/ReportTabs/RecurringPaymentsReport'
import CashflowAnalysisWrapper from '../../components/pages/ReportDetails/ReportTabs/CashflowAnalysis'
import BouncedCheques from '../../components/pages/ReportDetails/ReportTabs/BouncedCheques'
import Categories from '../../components/pages/ReportDetails/ReportTabs/Categories'
import Cashflow from '../../components/pages/ReportDetails/ReportTabs/CashflowReport'
import MonthlyCounterparty from '../../components/pages/ReportDetails/ReportTabs/MonthlyCounterpartyReport'
import BizCashflow from '../../components/pages/ReportDetails/ReportTabs/BizCashflow'
import Counterparty from '../../components/pages/ReportDetails/ReportTabs/Counterparty'
import { getReportDetailByReferrenceId } from '../../api/reportDetails'
import { setReportDetails, setSelectedAccount } from '../../store/reducers/slices/reportDetails.slice'
import { TabsEnum } from '../../utils/Enum/ReportTabsEnum'
import RecurringDeposites from '../../components/pages/ReportDetails/ReportTabs/RecurringDeposites'
import IntraBankTransfers from '../../components/pages/ReportDetails/ReportTabs/IntraBankTransfers'
import DuplicateTxn from '../../components/pages/ReportDetails/ReportTabs/DuplicateTxns'
import CircularTxn from '../../components/pages/ReportDetails/ReportTabs/CircularTxns'
import ODCCUtilization from '../../components/pages/ReportDetails/ReportTabs/ODCCUtilization'

const ReportDetails = () => {
    const [activeTab, setActiveTab] = useState(ReportTabs[0].value);
    const dispatch = useDispatch();
    const params = useParams();

    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    
    console.log("PARAMS::::::", params);

    useEffect(() => {
        getReportDetailByReferrenceId(params.id).then((resp) => {
            console.log("resp", resp);
            dispatch(setReportDetails(resp));
            if (resp.reportAccounts && resp.reportAccounts.length > 0) {
                dispatch(setSelectedAccount(resp.reportAccounts[0].account.accountId))
                dispatch(setNavBredcrumb([{ title: "Reports" }, { title: resp.report.reportName }]))
            }
        }).catch((error) => {
            console.log("error", error)
        })
    }, [])

    const handleTabClick = (value) => {
        if (activeTab !== value) {
            setActiveTab(value)
        }
    }

    const renderReport = (active) => {
        switch (active) {
            case TabsEnum.SUMMARY:
                return <SummaryReport />
            case TabsEnum.OVERVIEW:
                return <OverviewReport
                    onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.TRANSACTION:
                return <TransactionReport />
            case TabsEnum.AMLANALYSIS:
                return <AMLAnalysisReport
                    onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.MONTHLYSUMMARY:
                return <MonthlySummaryReport />
            case TabsEnum.UPITXNANALYSIS:
                return <UPITxnAnalysisWrapper />
            case TabsEnum.DAILYBALANCE:
                return <DailyBalanceReport />
            case TabsEnum.SALARY:
                return <SalaryReport 
                onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.BOUNCEDCHEQUES:
                return <BouncedCheques />
            case TabsEnum.CATEGORIES:
                return <Categories 
                onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.IRREGULARITIES:
                return <IrregularitiesPageWrapper />
            case TabsEnum.CASHFLOW:
                return <Cashflow />
            case TabsEnum.CASHFLOWANALYSIS:
                return <CashflowAnalysisWrapper 
                    onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.BUSINESSCASHFLOW:
                return <BizCashflow />
            case TabsEnum.MONTHLYCOUNTERPARTY:
                return <MonthlyCounterparty />
            case TabsEnum.COUNTERPARTY:
                return <Counterparty 
                    onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.RECURRINGPAYMENTS:
                return <RecurringPayments 
                    onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.EMIPAYMENT:
                return <EmiPayments 
                onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.LOANANALYSIS:
                return <LoanAnalysis />
            case TabsEnum.LOAN:
                return <Loans 
                onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.AVAILABLEBALANCE:
                return <AvailableBalance />
            case TabsEnum.INTRABANKTRANSFER:
                return <IntraBankTransfers />
            case TabsEnum.ODCCUTILIZATION:
                return <ODCCUtilization />
            case TabsEnum.RECURRINGDEPOSIT:
                return <RecurringDeposites 
                    onClickTabChange={(tab) => setActiveTab(tab)}
                />
            case TabsEnum.DUPLICATETRANSACTION:
                return <DuplicateTxn />
            case TabsEnum.CIRCULARTRANSACTION:
                return <CircularTxn />
            default:
                return "No Data Found";
        }
    }

    return (
        <Row gutter={[16, 16]}>
            <Col lg={4}>
                <SiderCard setActiveTab={setActiveTab} className="sider-card" />
            </Col>
            <Col lg={20}>
                <ZCard className='mb-16 sticky-tabs'>
                    <Flex gap={8} wrap="wrap">
                        {
                            ReportTabs.map((tab) => (<>
                                {/* {console.log("REPORT TAB>>>>>>", tab)} */}
                                
                                {selectedAccountId === 'all' && (tab?.value === 'transactions' || tab?.value === 'txnsSummary' || tab?.value === 'amlAnalysis' || tab?.value === 'closingBalance' || tab?.value === 'cashFlowAnalysis') ? "":<Button type={activeTab === tab.value ? "primary" : "default"} key={tab.value} onClick={() => handleTabClick(tab.value)}>{tab.label}</Button>}
                                </>
                            ))
                        }
                    </Flex>
                </ZCard>
                {renderReport(activeTab)}
            </Col>
        </Row>
    )
}

export default ReportDetails